import { useEffect, useState } from 'react'
import { useNotifications } from '../contexts/NotificationContext'
import NotificationToast from './NotificationToast'
import {
  MAX_VISIBLE_TOASTS,
  TOAST_LEAVE_DURATION,
  mergeToastSlots,
  visibleToasts,
} from '../utils/notificationPolicy'
import './NotificationContainer.css'

const NotificationContainer = () => {
  const { notifications, dismissToast } = useNotifications()
  const [slots, setSlots] = useState([])

  useEffect(() => {
    const visible = visibleToasts(notifications, MAX_VISIBLE_TOASTS)
    setSlots((previous) => mergeToastSlots(previous, visible))
  }, [notifications])

  // Les toasts sortants libèrent leur place une fois l’animation terminée
  useEffect(() => {
    if (!slots.some((slot) => slot.leaving)) return undefined
    const timer = setTimeout(() => {
      setSlots((previous) => previous.filter((slot) => !slot.leaving))
    }, TOAST_LEAVE_DURATION)
    return () => clearTimeout(timer)
  }, [slots])

  if (slots.length === 0) return null

  return (
    <div className="notification-container">
      {slots.map((slot) => (
        <div
          key={slot.notification.id}
          className={`notification-slot${slot.leaving ? ' is-leaving' : ''}`}
        >
          <div className="notification-slot-inner">
            <NotificationToast
              notification={slot.notification}
              onDismiss={() => dismissToast(slot.notification.id)}
            />
          </div>
        </div>
      ))}
    </div>
  )
}

export default NotificationContainer
